const ContactPage = ({ theme, onBackClick }) => {

    return (
      <div className='contactPage'>
          
        <h3>Contact</h3>
        <p>Email me at vianhnguyen17@gmail.com for professional enquiries.</p>
        <p>(I'm gonna add a contact form eventually)</p>
      </div>
    );
  };
  
  export default ContactPage;